<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card>
          <v-card-title>Resetuj hasło</v-card-title>
          <v-card-text>
            <v-form ref="resetForm" v-model="valid">
              <v-text-field v-model="email" :label="$t('changePassword.email')" outlined dense single-line required
                validate-on-blur :rules="emailRules"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color='primary' :disabled="submitLoading" :loading="submitLoading" @click='resetPassword'>Reset</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <ResetPasswordCodeVerification ref="resetCode" :email="email" />
  </v-container>
</template>
<script>
import Service from '@/services'
import ResetPasswordCodeVerification from './ResetPasswordCodeVerification.vue'
export default {
  components: { ResetPasswordCodeVerification },
  name: 'ResetPassword',
  data () {
    return {
      email: '',
      submitLoading: false,
      valid: true,
      emailRules: [
        v => !!v.trim() || this.$t('validation.emailRequired'),
        v => /.+@.+/.test(v) || this.$t('validation.incorrectEmailAddress')
      ]
    }
  },
  methods: {
    async resetPassword () {
      this.$refs.resetForm.validate()
      if (!this.valid) {
        return
      }
      this.submitLoading = true
      try {
        await Service.post('/Authentication/GeneratePasswordResetCode', { email: this.email })
        this.$refs.resetCode.show()
      } catch (error) {}
    }
  }
}
</script>
